<div>
    @if (atgarderSelection && !arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
    <rask-selector
        aid="atgarderSelection"
        label="Välj åtgärd"
        [values]="atgarderSelection"
        [viewFormatter]="atgarderSelectionViewFormatter"
        (change)="onAtgarderSelectionChanged()"
        [(ngModel)]="selectedAtgard">
    </rask-selector>
    }
</div>
<div>
    @if (atgarderTabs) {
    <rask-tabs aid="atgarderTabs" [useRoute]="false" layout="child">
        @for (tab of visibleAtgarderTabs(); track $index) {
        <rask-tab (onTabSelected)="setTab(tab)" [label]="getTabName(tab)"></rask-tab>
        }
    </rask-tabs>
    }
</div>
@if (selectedAtgard) {
<div>
    @if (currentTab?.name === 'Sammanfattning') {
    <div>
        @if (!isAtgardSelected()) {
        <div>
            @if (arbetsorder.isTerminalImport && arbetsorder.viol3) {
            <rask-arbetsorder-info-summary-terminalimport
                [arbetsorder]="arbetsorder"
                [validationContext]="validationContext">
            </rask-arbetsorder-info-summary-terminalimport>
            }
            @if (arbetsorder.isExternArbetsorder) {
            <rask-arbetsorder-info-summary-extern
                [arbetsorder]="arbetsorder"
                [validationContext]="validationContext">
            </rask-arbetsorder-info-summary-extern>
            }
            @if (!arbetsorder.isTerminalImport && !arbetsorder.isExternArbetsorder) {
            <rask-arbetsorder-info-summary
                [arbetsorder]="arbetsorder"
                [validationContext]="validationContext">
            </rask-arbetsorder-info-summary>
            }
        </div>
        }
        @if (isAtgardSelected()) {
        <div>
            <rask-atgard-info-summary
                [atgard]="selectedAtgard"
                [arbetsorder]="arbetsorder"
                [canSave]="canSave"
                [isEditable]="isEditable"
                [updatedAtgardBarighet]="updatedAtgardBarighet"
                [setFormDirty]="setFormDirty">
            </rask-atgard-info-summary>
        </div>
        }
    </div>
    }
    @if (currentTab?.name === 'Direktutbyte') {
    <div>
        <rask-arbetsorder-direktutbyte
            [arbetsorder]="arbetsorder"
            [atgard]="isAtgardSelected() ? selectedAtgard : null"
            [produktgrupper]="produktgrupper"
            [setFormDirty]="setFormDirty">
        </rask-arbetsorder-direktutbyte>
    </div>
    }
    @if (currentTab?.name === 'Anteckningar') {
    <div>
        <rask-arbetsorder-info-anteckningar>
        </rask-arbetsorder-info-anteckningar>
    </div>
    }
    @if (currentTab?.name === 'Dokument') {
    <div>
        <rask-arbetsorder-dokument
            [arbetsorder]="arbetsorder">
        </rask-arbetsorder-dokument>
    </div>
    }
    @if ((eudrFeatureActive$ | async) && currentTab?.name === 'EUDR') {
    <rask-checkbox [disabled]="!isImport()" class="col" text="EUDR status krävs ej" [(ngModel)]="arbetsorder.ejEudr"
        (ngModelChange)="setEjEudr($event)">
    </rask-checkbox>

    @if (!arbetsorder.ejEudr){
    @if(arbetsorder.isTerminalImport || arbetsorder.isExternArbetsorder) {
    <div>
        <rask-arbetsorder-eudr
            [arbetsorder]="arbetsorder"
            [validationContext]="validationContext">
        </rask-arbetsorder-eudr>
    </div>
    } @else {
    <div>
        <rask-eudr-status
            [arbetsorder]="arbetsorder">
        </rask-eudr-status>
    </div>
    }
    }
    }
</div>
}